export enum GridVariant {
  Half = 'half',
  FullLine = 'full-line',
  OneSidedSmall = 'one-sided-small',
  OneSidedLarge = 'one-sided-large',
}
